<template>
	<div class="subscription-payment-dialog">
		<header class="dialog-heading">
			<span class="dialog-icon" aria-hidden="true">
				<portal-icon name="receipt-text" :size="20"></portal-icon>
			</span>
			<h2>{{ $t('subscriptions.heading') }}</h2>
			<button type="button" class="dialog-close" :aria-label="$t('global.close')" @click="$emit('result')">
				<portal-icon name="x" :size="19"></portal-icon>
			</button>
		</header>

		<div class="subscription-payment-table-shell portal-compact-list-shell">
			<v-data-table
				class="portal-compact-table subscription-payment-table"
				:headers="headers"
				:items="payments"
				:mobile-breakpoint="0"
				disable-pagination
				hide-default-footer
			>
				<template v-slot:item.amount="{ item }">
					<strong>{{ $formatters.dollars(item.amount, true, true, item.currency) }}</strong>
				</template>
				<template v-slot:item.paid="{ item }">
					<portal-status-pill
						:background="item.paid ? 'var(--v-success_10-base)' : 'var(--v-gray_20-base)'"
						:color="item.paid ? 'var(--v-success-base)' : 'var(--portal-muted)'"
					>
						{{ $formatters.yesNoFromBoolean(item.paid) }}
					</portal-status-pill>
				</template>
			</v-data-table>
		</div>

		<footer class="dialog-footer">
			<button type="button" class="done-action" @click="$emit('result')">{{ $t('global.done') }}</button>
		</footer>
	</div>
</template>

<script>
	import SubscriptionService from '@/modules/subscriptions/SubscriptionService';
	import PortalIcon from '@/components/PortalIcon.vue';
	import PortalStatusPill from '@/components/PortalStatusPill.vue';

  export default {
		name: 'SubscriptionPayments',

		props: ['subscription'],

		components: { PortalIcon, PortalStatusPill },

		data: function () {
			return {
				payments: [],
				stripeSubscriptionService: new SubscriptionService(),
				headers: [
					{ text: this.$t('stripe.subscription.period-start'), value: 'periodStart' },
					{ text: this.$t('stripe.subscription.period-end'), value: 'periodEnd' },
					{ text: this.$t('stripe.subscription.invoice-amount'), value: 'amount' },
					{ text: this.$t('stripe.subscription.paid'), value: 'paid' },
				],
			};
		},

		mounted() {
			this.getPayments();
		},

		beforeDestroy() {},

		methods: {
			getPayments: function () {
				this.stripeSubscriptionService.getSubscriptionPayments(this.subscription.id).then((res) => {
					this.payments.splice(0, this.payments.length);
					this.payments.push(...res.data);
				});
			},
		},

		computed: {},
	};
</script>

<style scoped lang="scss">
	.subscription-payment-dialog {
		width: min(760px, calc(100vw - 32px));
		max-height: min(720px, calc(100vh - 32px));
		display: flex;
		flex-direction: column;
		overflow: hidden;
		border-radius: var(--brand-surface-radius, 18px);
		background: var(--portal-surface);
	}

	.dialog-heading {
		min-height: 68px;
		display: flex;
		align-items: center;
		gap: 11px;
		padding: 14px 18px;
		border-bottom: 1px solid var(--portal-border);
	}

	.dialog-heading h2 {
		min-width: 0;
		flex: 1;
		margin: 0;
		color: var(--portal-text);
		font-size: 17px;
		font-weight: 650;
	}

	.dialog-icon,
	.dialog-close {
		display: grid;
		place-items: center;
		border-radius: 11px;
	}

	.dialog-icon {
		width: 38px;
		height: 38px;
		background: color-mix(in srgb, var(--v-primary-base) 9%, var(--portal-surface));
		color: var(--v-primary-base);
	}

	.dialog-close {
		width: 36px;
		height: 36px;
		border: 0;
		background: transparent;
		color: var(--portal-muted);
		cursor: pointer;
	}

	.dialog-close:hover {
		background: var(--v-gray_20-base);
		color: var(--portal-text);
	}

	.subscription-payment-table-shell {
		min-width: 0;
		flex: 1;
		overflow: auto;
		padding: 16px 18px;
	}

	.dialog-footer {
		display: flex;
		justify-content: flex-end;
		padding: 14px 18px;
		border-top: 1px solid var(--portal-border);
	}

	.done-action {
		min-width: 120px;
		min-height: 42px;
		padding: 0 16px;
		border: 0;
		border-radius: var(--brand-button-radius, 11px);
		background: var(--v-primary-base);
		color: var(--v-white-base);
		font: inherit;
		font-size: 13px;
		font-weight: 650;
		cursor: pointer;
	}

	@container portal-compact-list (max-width: 520px) {
		.subscription-payment-table ::v-deep th:nth-child(2),
		.subscription-payment-table ::v-deep td:nth-child(2) {
			display: none;
		}
	}
</style>
